import React from 'react'

const PestMonitoringCompnent = () => {
  return (
    <div>PestMonitoring</div>
  )
}

export default PestMonitoringCompnent;